export const SERVER_URL = process.env.REACT_APP_API_SERVER_URL;
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL;
export const FIREBASE_CONFIG = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
	databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
};

export const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;

export const AppRoutesConfig = {
	MACHINE_SELECT: {
		path: "/",
		match: "/",
	},
	MACHINE: {
		TASK: {
			MANAGER: {
				path: "",
				match: "/:id/", // Default route
			},
			HISTORY: {
				path: "task/history",
				match: "/:id/task/history",
			},
		},
		INVENTORY_PLAN: {
			LIST: {
				path: "inventoryPlan/list",
				match: "/:id/inventoryPlan/list",
			},
			CREATE: {
				path: "inventoryPlan/create",
				match: "/:id/inventoryPlan/create",
			},
			DETAILS: {
				path: "inventoryPlan/details/:id",
				match: "/:id/inventoryPlan/details/:id",
			},
			EDIT: {
				path: "inventoryPlan/edit/:id",
				match: "/:id/inventoryPlan/edit/:id",
			},
			CURRENT_INVENTORY: {
				path: "inventoryPlan/currentInventory",
				match: "/:id/inventoryPlan/currentInventory",
			},
		},
	},
};
export const SidebarLinks = {
	TASK: {
		title: "Replenishment Plans",
		hasSubLinks: true,
		isMaterialIcon: true,
		icon: "add_task",
		subLinks: [
			{
				title: "Task Manager",
				route: AppRoutesConfig.MACHINE.TASK.MANAGER,
				isMaterialIcon: true,
				icon: "order_play",
			},
			{
				title: "History",
				route: AppRoutesConfig.MACHINE.TASK.HISTORY,
				isMaterialIcon: true,
				icon: "list_alt",
			},
		],
	},
	INVENTORY_PLAN: {
		title: "Inventory Plans",
		hasSubLinks: true,
		isMaterialIcon: true,
		icon: "add_task",
		subLinks: [
			{
				title: "Current Inventory",
				route: AppRoutesConfig.MACHINE.INVENTORY_PLAN.CURRENT_INVENTORY,
				isMaterialIcon: true,
				icon: "list_alt",
			},
			{
				title: "Inventory Plans",
				route: AppRoutesConfig.MACHINE.INVENTORY_PLAN.LIST,
				isMaterialIcon: true,
				icon: "order_play",
			},
			{
				title: "Create Plan",
				route: AppRoutesConfig.MACHINE.INVENTORY_PLAN.CREATE,
				isMaterialIcon: true,
				icon: "list_alt",
			},
		],
	},
};
export const DEFAULT_QUANTITY_UNIT = "g";
